import { passwordIssues } from '@financas/shared';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../app/auth-context';
import { ApiError, api } from '../../lib/api';

/**
 * Aceite de convite. O e-mail nao e pedido: ele ja veio preso ao token, e
 * deixar o convidado digitar outro permitiria desviar o convite.
 */
export function AcceptInvitePage() {
  const { token = '' } = useParams<{ token: string }>();
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const issues = password ? passwordIssues(password, { name }) : [];
  const mismatch = confirmPassword.length > 0 && password !== confirmPassword;
  const canSubmit =
    name.length >= 2 && issues.length === 0 && !mismatch && confirmPassword.length > 0;

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const result = await api.acceptInvite({ token, name, password });
      signIn(result.user, result.accessToken);
      navigate('/seguranca?primeiro-acesso=1', { replace: true });
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : 'Nao foi possivel aceitar o convite.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-screen">
      <main className="auth-card">
        <h1>Aceitar convite</h1>
        <p className="subtitle">Crie sua senha para entrar nas financas da casa.</p>

        {error && (
          <div className="alert error" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={onSubmit} noValidate>
          <div className="field">
            <label htmlFor="name">Seu nome</label>
            <input
              id="name"
              autoComplete="name"
              autoFocus
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          </div>

          <div className="field">
            <label htmlFor="password">Senha</label>
            <input
              id="password"
              type="password"
              autoComplete="new-password"
              aria-invalid={issues.length > 0}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
            {issues.length > 0 ? (
              <span className="field-error">{issues[0]}</span>
            ) : (
              <span className="field-hint">Ao menos 12 caracteres, com variedade.</span>
            )}
          </div>

          <div className="field">
            <label htmlFor="confirmPassword">Confirme a senha</label>
            <input
              id="confirmPassword"
              type="password"
              autoComplete="new-password"
              aria-invalid={mismatch}
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
            />
            {mismatch && <span className="field-error">As senhas nao conferem.</span>}
          </div>

          <button className="btn block" type="submit" disabled={!canSubmit || submitting}>
            {submitting ? 'Criando...' : 'Criar conta'}
          </button>
        </form>
      </main>
    </div>
  );
}
